import React, {Component} from 'react'
import { ProjectContainer, ProjectH1 } from './ProjectElements'
//import reactDom from 'react-dom'
import Carousel from'react-elastic-carousel';
import Item from './items';
import Jump from 'react-reveal/Jump';
//import { Link } from 'react-router-dom';
//import * as miniPreview from './onHover';
//import $ from 'jquery';
const breakPoints = [
    { height: 1, itemToShow: 1},
    { width: 550, itemToShow: 2},
    { width: 768, itemToShow: 3},
    { width: 1200, itemToShow: 4},

];
const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }


function Projects() {
    <>
    <script src="https://ajax.googleapis.com/ajax/libs/jquery/2.0.3/jquery.min.js"/>
  <link href="https://rawgit.com/shaneapen/Image-Preview-for-Links/master/image_preview_for_links.css" rel="stylesheet"/>     
  <script type="text/javascript">
    
  </script> 
  <script src="https://rawgit.com/shaneapen/Image-Preview-for-Links/master/image_preview_for_links.js"/>
    </>
   

    return (
      

        <ProjectContainer id="projects">
            <ProjectH1>Projects</ProjectH1>
            <Carousel breakPoints={breakPoints} >
                
                <Item onClick={() => openInNewTab('https://thermomassage.ro')}><Jump>thermomassage.ro</Jump></Item>
                
                <Item onClick={() => openInNewTab('https://mystifying-carson-8c1c88.netlify.app')}><Jump>AltMobili(Work in Progress)</Jump></Item>
                
                <Item onClick={() => openInNewTab('https://play.google.com/store/apps/developer?id=KHApps')}><Jump>KHApps(Google Play Store Account)</Jump></Item>

                <Item onClick={() => openInNewTab('https://admiring-wiles-80db62.netlify.app')}><Jump>ReményApp (Online)</Jump></Item>

                <Item onClick={() => openInNewTab('http://your-chat-app.herokuapp.com')}><Jump>YourChatApp</Jump></Item>

                <Item onClick={() => openInNewTab('https://teendo.netlify.app')}><Jump>TodoList</Jump></Item>
            
                <Item onClick={() => openInNewTab('https://pontosido.netlify.app')}><Jump>PontosIdő</Jump></Item>

                <Item onClick={() => openInNewTab('http://uzenofal.herokuapp.com')}><Jump>Üzenőfal</Jump></Item>
            </Carousel>
            </ProjectContainer>
            
    )
}



export default Projects
